module.exports = __webpack_public_path__ + "static/media/No-data.779eb00a.webp";